import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { PriceSection } from './components/PriceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { LegalModal } from './components/LegalModal';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  const [legalModal, setLegalModal] = useState<{
    open: boolean;
    type: 'terms' | 'privacy';
  }>({
    open: false,
    type: 'terms'
  });
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-navy-900 text-slate-200 font-body selection:bg-cyan-500/30 selection:text-cyan-100" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <PriceSection data-id="element-4" />
      <GuaranteeSection data-id="element-5" />

      <footer className="py-8 text-center text-slate-600 text-sm border-t border-navy-800" data-id="element-6">
        <p data-id="element-7">
          © {new Date().getFullYear()} Protocolo Cortisol-Zero™. Todos los
          derechos reservados.
        </p>
        <p className="mt-2 text-xs max-w-xl mx-auto px-4" data-id="element-8">
          Este producto no sustituye el consejo médico profesional. Los
          resultados pueden variar.
        </p>
        <div className="mt-4 flex items-center justify-center gap-4 text-xs" data-id="element-9">
          <button onClick={() => setLegalModal({
          open: true,
          type: 'terms'
        })} className="text-slate-500 hover:text-cyan-400 transition-colors underline underline-offset-2" data-id="element-10">
            Términos y Condiciones
          </button>
          <span className="text-slate-700" data-id="element-11">•</span>
          <button onClick={() => setLegalModal({
          open: true,
          type: 'privacy'
        })} className="text-slate-500 hover:text-cyan-400 transition-colors underline underline-offset-2" data-id="element-12">
            Política de Privacidad
          </button>
        </div>
      </footer>

      <LegalModal isOpen={legalModal.open} type={legalModal.type} onClose={() => setLegalModal(prev => ({
      ...prev,
      open: false
    }))} data-id="element-13" />
    </main>;
}